import React from "react";
import { PaymentRowLayout } from "./PaymentRowLayout";
import {
  CreditCardProgram,
  PaymentType,
} from "../../../../constants/TransactionConstants";

export default function PaymentPasses(props) {
  const { transaction, paymentCredit, data } = props;

  const isFullyPayPass = transaction.paymentType === PaymentType.Pass;

  const isShow = data.length > 0 && !isFullyPayPass;

  if (!isShow) return null;

  const paymentMethod =
    CreditCardProgram.getName(paymentCredit.creditCardProgram) ||
    (isFullyPayPass ? data?.map((x) => x.passProgramName).join(", ") : "");
  const passPaymentCodes = data?.map((x) => x.passCode).join(", ");

  return (
    <PaymentRowLayout
      first={paymentMethod}
      second={passPaymentCodes}
      third={`$ 0`}
    />
  );
}
